export default "__VITE_ASSET__DhSJRrNw__"